import React from "react";

import { VideoRekognitionResultContext } from "../context/VideoRekognitionResultContext";

export const useVideoRekognitionResultContext = () => {
    return React.useContext(VideoRekognitionResultContext);
};
